export class CanaisComunicacaoTelefoniaEvento {
  constructor(
    public acao: string,
    public identificacao: string,
    public codigo_no_erp_do_cliente: string,
    public numero_telefone: string = "",
    public vendedor_externo: string = "",
    public vendedor_interno: string = ""
  ) { }
}
